import React from 'react';

// I will hardcode the data from testimonials/index.js since it's hardcoded there anyway.
const TestimonialData = [
    {
        "name": "Alakendu Sarkar",
        "role": "Lead Consultant Stroke Neurologist",
        "location": "The Walton Center, Liverpool",
        "profile_image": require("../../../images/testamonials/alakendu_sarkar.png"),
        "comment": "This tool is wonderful and I found it very user-friendly"
    },
    {
        "name": "Ahjoku Amadi-Obi",
        "role": "Research Fellow (Telemedicine)",
        "location": "Royal College of Surgeons of Ireland",
        "profile_image": require("../../../images/testamonials/ahjoku_amadi_obi.png"),
        "comment": "I find this an excellent resource for clinicians"
    },
    {
        "name": "Dr. Regan Solomons",
        "role": "Paediatric Neurologist",
        "location": "University of Stellenbosch",
        "profile_image": require("../../../images/testamonials/regan_solomons.png"),
        "comment": "The app is good. It is concise and will be easy to access"
    }
];

export default function MarketingTestimonials() {
    // Generate initials for the avatar if image fails to load or just as a fallback.
    const getInitials = (name) => {
        let parts = name.replace('Dr. ', '').split(' ');
        if (parts.length > 1) {
            return parts[0][0] + parts[1][0];
        }
        return parts[0][0];
    };

    const colors = [
        'linear-gradient(135deg,#1E40AF,#2563EB)',
        'linear-gradient(135deg,#065F46,#059669)',
        'linear-gradient(135deg,#7C3AED,#6D28D9)'
    ];

    return (
        <div className="testimonials-section">
            <div className="testimonials-inner">
                <div className="eyebrow reveal" style={{ justifyContent: 'center' }}>
                    <div className="eyebrow-line"></div>
                    <span className="eyebrow-text">What researchers say</span>
                    <div className="eyebrow-line"></div>
                </div>
                <h2 className="section-title reveal reveal-delay-1">Trusted by the people<br />doing the work</h2>
                <p className="section-sub reveal reveal-delay-2">From clinical fellows to department heads — Axon is changing how neurology research gets done.</p>

                <div className="testi-grid">
                    {TestimonialData.map((item, index) => (
                        <div className="testi-card reveal" style={{ animationDelay: `${(index + 1) * 0.1}s` }} key={index}>
                            <div className="testi-stars">★★★★★</div>
                            <div className="testi-quote">{item.comment}</div>
                            <div className="testi-divider"></div>
                            <div className="testi-author">
                                <div className="testi-av" style={{ background: colors[index % colors.length] }}>
                                    {getInitials(item.name)}
                                </div>
                                <div>
                                    <div className="testi-name">{item.name}</div>
                                    <div className="testi-role">{item.role} · {item.location}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
